import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';


export async function getTermsAndConditions(language) {
  const docRef = doc(db, 'settings', 'legal');
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const data = docSnap.data().termsAndConditions;
    return data[language]['text']
  } else {
    throw new Error("Terms document does not exist");
  }
}